import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Callback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = setInterval(() => {
      const token = sessionStorage.getItem("access_token");
      const isAuthenticated = sessionStorage.getItem("isAuthenticated") === "true";
      
      if (token && isAuthenticated) {
        clearInterval(checkAuth);
        navigate("/TemplateList", { replace: true });
      }
    }, 100);

    // Timeout after 10 seconds
    const timeout = setTimeout(() => {
      clearInterval(checkAuth);
      console.error("Authentication timeout");
      navigate("/signIn", { replace: true });
    }, 100000);

    return () => {
      clearInterval(checkAuth);
      clearTimeout(timeout);
    };
  }, [navigate]);

  return null;
};

export default Callback;